import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from "../utils";

interface UseDeleteBindingUserParams {
    bindingType: number;
    id: string;
};

export const useDeleteBindingUser = () => {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    return useMutation({
        mutationFn: async ({ bindingType, id }: UseDeleteBindingUserParams) => {
            try {
                return (await api.delete(`/binding-user/delete/${bindingType}/${id}`, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar usuário vinculado');
            }
        },
        onSuccess: (_data, { bindingType, id }) => {
            queryClient.invalidateQueries({ queryKey: ['binding-users'] });
            queryClient.invalidateQueries({ queryKey: ['binding-user', bindingType, id] });
        },
        onError: (error) => {
            console.error('Erro ao deletar usuário vinculado:', getApiErrorMessage(error, 'Erro ao deletar usuário vinculado'))
        }
    })
}
